import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { Preferences } from '@capacitor/preferences';

export const useAppUpdater = () => {
	const UPDATE_URL = useRuntimeConfig().public.UPDATES_URL;
	const VERSION_KEY = 'app_current_version';
	let hasUpdate = ref(false);

	const initUpdater = async () => {
		console.log('initUpdater');

		if (process.env.CAP_UPDATER_ENABLED === 'false') {
			return { hasUpdate };
		}

		try {
			await CapacitorUpdater.notifyAppReady();
		} catch (e) {
			console.log('Capgo Cloud error ignored (429)');
		}

		try {
			console.log('UPDATE_URL________________');
			console.log(UPDATE_URL);

			if (!UPDATE_URL) return;
			const { value } = await Preferences.get({ key: VERSION_KEY });
			const appVersion = String(useRuntimeConfig().public.appVersion || '1.0.0');
			const savedVersion = value ? String(value) : '1.0.0';

			const currentVersion = isNewVersionGreater(savedVersion, appVersion) ? appVersion : savedVersion;
			console.log('currentVersion________________');
			console.log(currentVersion);
			const response = await fetch(`${UPDATE_URL}/version.json`);
			const serverData = await response.json();

			console.log(`[MyUpdater] Local: ${currentVersion} | Server: ${serverData.version}`);

			if (serverData.version && isNewVersionGreater(currentVersion, String(serverData.version))) {
				console.log('🚀 Обновление найдено!');
				if (serverData?.isForce) {
					hasUpdate.value = true;
				}
				await runUpdate(serverData.url, serverData.version, serverData?.isForce);
			} else {
				hasUpdate.value = false;
			}
		} catch (e) {
			console.error('❌ Ошибка логики обновления:', e);
			hasUpdate.value = false;
		} finally {
			return { hasUpdate };
		}
	};

	const runUpdate = async (url: string, version: string, isForce: boolean) => {
		try {
			const update = await CapacitorUpdater.download({ url, version });

			await Preferences.set({ key: VERSION_KEY, value: version });
			if (isForce) {
				await CapacitorUpdater.set(update);
			}
		} catch (e) {
			console.error('❌ Ошибка скачивания ZIP:', e);
			hasUpdate.value = false;
		}
	};

	return { initUpdater, hasUpdate };
};

function isNewVersionGreater(current: string, server: string): boolean {
	const currentParts = current.split('.').map(Number);
	const serverParts = server.split('.').map(Number);

	for (let i = 0; i < Math.max(currentParts.length, serverParts.length); i++) {
		const currentPart = currentParts[i] || 0;
		const serverPart = serverParts[i] || 0;

		if (serverPart > currentPart) return true;
		if (serverPart < currentPart) return false;
	}
	return false;
}
